/* Omalait V2 — Octobre Rose : interactions légères (sans dépendance) */
(function () {
  if (window.__orv2) return; window.__orv2 = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(n) { return Math.round(n).toLocaleString('fr-FR') + ' €'; }
  function eur(n) { return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }

  function initReveal(root) {
    var els = root.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-orv2-tabs]').forEach(function (box) {
      if (box.__done) return; box.__done = true;
      var tabs = box.querySelectorAll('[role=tab]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t; o.setAttribute('aria-selected', on);
            var p = box.querySelector('#' + o.getAttribute('aria-controls')); if (p) p.hidden = !on;
          });
        });
      });
    });
  }

  function initBA(root) {
    root.querySelectorAll('[data-orv2-ba]').forEach(function (ba) {
      var r = ba.querySelector('input'); if (!r || r.__done) return; r.__done = true;
      var set = function () { ba.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set); set();
    });
  }

  function animateNumber(el, to, fmt) {
    var from = el.__v || 0; el.__v = to;
    if (reduce) { el.textContent = fmt(to); return; }
    var t0 = null, dur = 600;
    function step(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur); k = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(from + (to - from) * k); if (k < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
    clearTimeout(el.__t); el.__t = setTimeout(function () { if (el.__v === to) el.textContent = fmt(to); }, dur + 150);
  }

  function initCalc(root) {
    root.querySelectorAll('[data-orv2-calc]').forEach(function (c) {
      if (c.__done) return; c.__done = true;
      var home = parseFloat(c.getAttribute('data-home')) || 0.8;
      var ins = c.querySelectorAll('input[type=range]'), bricksBox = c.querySelector('[data-bricks]');
      function set(sel, val) { var el = c.querySelector(sel); if (el) animateNumber(el, val, money); }
      function upd() {
        var v = {}; ins.forEach(function (i) {
          v[i.name] = parseFloat(i.value);
          var p = (i.value - i.min) / (i.max - i.min) * 100; i.style.setProperty('--p', p + '%');
          var o = c.querySelector('output[for=' + i.id + ']');
          if (o) o.textContent = i.name === 'litres' ? i.value + ' L par semaine' : eur(parseFloat(i.value)) + ' / L';
        });
        var litresYear = v.litres * 52, year = litresYear * v.shop;
        set('[data-year]', year); set('[data-five]', year * 5); set('[data-home-year]', litresYear * home);
        var nb = c.querySelector('[data-nb]'); if (nb) nb.textContent = Math.round(litresYear * 5).toLocaleString('fr-FR');
        if (bricksBox) {
          var n = Math.min(52, Math.round(litresYear)), html = '';
          for (var k = 0; k < 52; k++) html += '<i' + (k < n ? ' class="on"' : '') + '></i>';
          bricksBox.innerHTML = html + '<span>' + Math.round(litresYear) + ' briques par an</span>';
        }
      }
      ins.forEach(function (i) { i.addEventListener('input', upd); }); upd();
    });
  }

  function initHotspots(root) {
    root.querySelectorAll('[data-orv2-hs]').forEach(function (box) {
      if (box.__done) return; box.__done = true;
      var pts = box.querySelectorAll('.orv2-hs__pt');
      pts.forEach(function (p) {
        p.querySelector('button').addEventListener('click', function (e) {
          e.stopPropagation(); var open = !p.classList.contains('is-open');
          pts.forEach(function (o) { o.classList.remove('is-open'); o.querySelector('button').setAttribute('aria-expanded', 'false'); });
          if (open) { p.classList.add('is-open'); p.querySelector('button').setAttribute('aria-expanded', 'true'); }
        });
      });
      document.addEventListener('click', function () { pts.forEach(function (o) { o.classList.remove('is-open'); }); });
      if (pts[0] && window.innerWidth > 900) pts[0].classList.add('is-open');
    });
  }

  function initCountdown(root) {
    root.querySelectorAll('[data-orv2-cd]').forEach(function (cd) {
      if (cd.__done) return; cd.__done = true;
      var end = new Date(cd.getAttribute('data-end')).getTime();
      var box = cd.closest('[data-orv2-cdwrap]');
      function tick() {
        var d = Math.max(0, end - Date.now());
        if (d <= 0 && box) { box.hidden = true; return; }
        var s = Math.floor(d / 1000), parts = { j: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        Object.keys(parts).forEach(function (k) { var e = cd.querySelector('[data-' + k + ']'); if (e) e.textContent = String(parts[k]).padStart(2, '0'); });
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function initCopy(root) {
    root.querySelectorAll('[data-orv2-copy]').forEach(function (b) {
      if (b.__done) return; b.__done = true;
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-orv2-copy'), lbl = b.textContent;
        (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () {
          b.textContent = 'Copié ✓'; setTimeout(function () { b.textContent = lbl; }, 1600);
        }).catch(function () {});
      });
    });
  }

  function initSticky() {
    var s = document.querySelector('[data-orv2-sticky]'); if (!s || s.__done) return; s.__done = true;
    var hero = document.querySelector('.orv2-atc') || document.querySelector('.orv2-hero');
    var footer = document.querySelector('footer, .footer');
    function upd() {
      var y = window.scrollY, past = hero ? hero.getBoundingClientRect().bottom < 0 : y > 600;
      var nearEnd = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      s.classList.toggle('is-on', past && !nearEnd);
    }
    window.addEventListener('scroll', upd, { passive: true }); upd();
  }

  function initEmo(root) {
    root.querySelectorAll('[data-orv2-emo]').forEach(function (box) {
      if (box.__done) return; box.__done = true;
      var items = box.querySelectorAll('.orv2-emo__item'), imgs = box.querySelectorAll('.orv2-emo__stage img'), word = box.querySelector('.orv2-emo__word');
      function show(i) {
        items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
        if (word && items[i]) word.textContent = items[i].getAttribute('data-word') || '';
      }
      show(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) show(Array.prototype.indexOf.call(items, e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (it) { io.observe(it); });
    });
  }

  function initPdpBow() {
    var tpl = document.querySelector('template[data-orv2-bow]'); if (!tpl || tpl.__done) return; tpl.__done = true;
    var g = document.querySelector('media-gallery, .product__media-wrapper'); if (!g) return;
    var host = g.querySelector('slider-component') || g;
    host.style.position = 'relative';
    host.appendChild(tpl.content.cloneNode(true));
  }

  function initGallery(root) {
    root.querySelectorAll('[data-orv2-gal]').forEach(function (g) {
      if (g.__done) return; g.__done = true;
      var track = g.querySelector('[data-track]'); if (!track) return;
      var slides = track.children, thumbs = g.querySelectorAll('.orv2-gal__thumb'), dots = g.querySelector('[data-dots]');
      if (dots) for (var i = 0; i < slides.length; i++) dots.appendChild(document.createElement('span'));
      function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
      function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function mark() { var c = cur(); thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === c); }); if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === c); }); }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var pv = g.querySelector('[data-prev]'), nx = g.querySelector('[data-next]');
      if (pv) pv.addEventListener('click', function () { go(cur() - 1); });
      if (nx) nx.addEventListener('click', function () { go(cur() + 1); });
      var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true }); mark();
    });
  }


  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + '€'; }

  /* Ajoute des lignes au panier via l'API Storefront (sans évènement « product_added_to_cart ») ; repli sur /cart/add.js */
  function orv2SfAdd(lines) {
    var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    function ajax() { return fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: lines }) }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); }); }
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      return fetch('/api/2025-10/graphql.json', { method: 'POST', headers: H, body: JSON.stringify({ query: 'mutation($id:ID!,$l:[CartLineInput!]!){cartLinesAdd(cartId:$id,lines:$l){cart{totalQuantity} userErrors{message}}}', variables: { id: 'gid://shopify/Cart/' + c.token, l: lines.map(function (x) { return { merchandiseId: 'gid://shopify/ProductVariant/' + x.id, quantity: x.quantity }; }) } }) })
        .then(function (r) { return r.json(); })
        .then(function (j) { var a = j && j.data && j.data.cartLinesAdd; if (!a || (a.userErrors && a.userErrors.length)) throw j; return j; });
    }).catch(ajax);
  }
  window.orv2SfAdd = orv2SfAdd;

  function initPack(root) {
    root.querySelectorAll('[data-orv2-pack]').forEach(function (pk) {
      if (pk.__done) return; pk.__done = true;
      var form = pk.closest('form'), btn = form.querySelector('.orv2-atc');
      var d = pk.dataset, price = +d.price, fprice = +d.filterPrice, bprice = +d.bottlePrice, duo = +d.duo; var blot = +d.bottleLotPrice || 0; function bcost(n){ return blot ? Math.floor(n/2)*blot + (n%2)*bprice : n*bprice; }
      var opts = pk.querySelectorAll('.orv2-opt'), extra = { filter: 0, bottle: 0 };
      function n() { var r = pk.querySelector('input[type=radio]:checked'); return r ? +r.value : 1; }
      function upd() {
        var q = n(), base = price * q;
        if (q >= 2) base = d.duoPrice ? +d.duoPrice : price * q - Math.round(price * q * duo / 100);
        var total = base + extra.filter * fprice + bcost(extra.bottle);
        pk.querySelector('[data-total]').textContent = fmt(total);
        opts.forEach(function (o) { o.classList.toggle('is-on', o.querySelector('input').checked); });
      }
      pk.querySelectorAll('input[type=radio]').forEach(function (r) { r.addEventListener('change', upd); });
      pk.querySelectorAll('[data-extra]').forEach(function (row) {
        var k = row.getAttribute('data-extra'), out = row.querySelector('output');
        row.querySelector('[data-plus]').addEventListener('click', function () { if (extra[k] < 20) extra[k]++; out.textContent = extra[k]; upd(); });
        row.querySelector('[data-minus]').addEventListener('click', function () { if (extra[k] > 0) extra[k]--; out.textContent = extra[k]; upd(); });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = n(), items;
        if (q >= 2 && d.duoVariant) { items = [{ id: +d.duoVariant, quantity: 1 }]; if (extra.filter > 0) items.push({ id: +d.filter, quantity: extra.filter }); }
        else if (d.freeFilter) { items = [{ id: +d.machine, quantity: q }, { id: +d.freeFilter, quantity: q }]; if (extra.filter > 0) items.push({ id: +d.filter, quantity: extra.filter }); }
        else items = [{ id: +d.machine, quantity: q }, { id: +d.filter, quantity: q + extra.filter }];
        if (extra.bottle > 0 && d.bottle) { if (d.bottleLot) { var nl = Math.floor(extra.bottle / 2), ns = extra.bottle % 2; if (nl) items.push({ id: +d.bottleLot, quantity: nl }); if (ns) items.push({ id: +d.bottle, quantity: ns }); } else items.push({ id: +d.bottle, quantity: extra.bottle * (+d.bottleQty || 1) }); }
        var err = pk.querySelector('[data-err]'); err.hidden = true; btn.classList.add('is-loading');
        /* 1 clic = 1 seul « ajout au panier » envoyé à Meta/Google : la machine passe par /cart/add.js,
           le filtre offert et les extras sont ajoutés ensuite par l'API Storefront (pas d'évènement en double). */
        var first = items.shift();
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [first] }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return items.length ? orv2SfAdd(items) : null; })
          .then(function () { if (window.orv2Cart && !/^\/cart\/?$/.test(location.pathname)) return window.orv2Cart.afterAdd().then(function () { btn.classList.remove('is-loading'); }); window.location.href = '/cart'; })
          .catch(function (j) { btn.classList.remove('is-loading'); err.textContent = (j && (j.description || j.message)) || 'Une erreur est survenue, merci de réessayer.'; err.hidden = false; });
      });
      upd();
    });
  }


  function initQty(root) {
    root.querySelectorAll('[data-orv2-qty]').forEach(function (q) {
      if (q.__done) return; q.__done = true;
      var i = q.querySelector('input'), mult = +q.dataset.mult || 0, real = mult ? q.parentElement.querySelector('[data-qty-real]') : null;
      function sync() { if (real) real.value = Math.max(1, +i.value || 1) * mult; }
      q.querySelector('[data-plus]').addEventListener('click', function () { i.value = Math.min(+i.max || 20, (+i.value || 1) + 1); sync(); });
      q.querySelector('[data-minus]').addEventListener('click', function () { i.value = Math.max(1, (+i.value || 1) - 1); sync(); });
      i.addEventListener('change', sync);
    });
  }


  function initTouchCards(root) {
    root.querySelectorAll('.orv2-chip, .orv2-card3d').forEach(function (c) {
      if (c.__done) return; c.__done = true;
      c.addEventListener('click', function () { c.classList.toggle('is-open'); });
    });
    if (window.matchMedia && window.matchMedia('(hover:hover)').matches && !reduce) {
      root.querySelectorAll('.orv2-tilt').forEach(function (t) {
        if (t.__tilt) return; t.__tilt = true; var box = t.parentElement;
        box.addEventListener('mousemove', function (e) { var r = box.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; t.style.transform = 'rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 8) + 'deg)'; });
        box.addEventListener('mouseleave', function () { t.style.transform = ''; });
      });
    }
  }

  function initCartUpsell(root) {
    root.querySelectorAll('[data-orv2-cu]').forEach(function (row) {
      if (row.__done) return; row.__done = true;
      var btn = row.parentElement.querySelector('[data-orv2-cu-add]'), label = btn.textContent;
      function sel() { return Array.prototype.filter.call(row.querySelectorAll('input'), function (i) { return i.checked; }); }
      function upd() { var s = sel(), tot = 0; s.forEach(function (i) { tot += +i.dataset.price; }); btn.disabled = !s.length; btn.textContent = s.length ? label + ' (+' + fmt(tot) + ')' : label; }
      row.addEventListener('change', upd);
      btn.addEventListener('click', function () {
        var items = sel().map(function (i) { return { id: +i.value, quantity: +i.dataset.qty || 1 }; }); if (!items.length) return;
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function () { location.reload(); }).catch(function () { btn.disabled = false; });
      });
    });
  }


  function initPopup() {
    var pop = document.querySelector('[data-orv2-pop]'); if (!pop || pop.__done) return; pop.__done = true;
    var tab = document.querySelector('[data-orv2-pop-tab]'), K = 'orv2_pop10', now = Date.now(), st = {};
    var mob = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
    try { st = JSON.parse(localStorage.getItem(K) || '{}'); } catch (e) {}
    function save(o) { try { localStorage.setItem(K, JSON.stringify(o)); } catch (e) {} }
    var isOpen = false, parked = false, forced = false;
    /* Le popup ne doit jamais cacher un bouton d'achat ni s'ouvrir quand le tiroir panier est ouvert */
    function drawerOpen() { var d = document.querySelector('cart-drawer'); return !!(d && d.classList.contains('active')) || document.body.classList.contains('overflow-hidden-drawer'); }
    function vis(el) { if (!el || !el.getClientRects().length) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight && r.width > 0; }
    function buyVisible() {
      var els = document.querySelectorAll('.orv2-atc, form[action*="/cart/add"] [type=submit], .product-form__submit');
      for (var i = 0; i < els.length; i++) { if (!pop.contains(els[i]) && vis(els[i])) return true; }
      var b = document.querySelector('.orv2-buy, [data-orv2-pack]'); return vis(b);
    }
    function blocked() { return drawerOpen() || (mob.matches && buyVisible()); }
    function place() { var sk = document.querySelector('.orv2-sticky.is-on'); pop.style.bottom = (mob.matches && sk) ? Math.round(window.innerHeight - sk.getBoundingClientRect().top + 8) + 'px' : ''; }
    function show() { place(); pop.hidden = false; if (tab) tab.hidden = true; document.documentElement.classList.add('orv2-pop-open'); }
    function hide() { pop.hidden = true; document.documentElement.classList.remove('orv2-pop-open'); }
    function open(f) { isOpen = true; forced = !!f; parked = false; if (!forced && blocked()) { parked = true; return; } show(); }
    function close() { isOpen = false; parked = false; hide(); if (!st.done && tab) tab.hidden = false; st.closed = Date.now(); save(st); }
    /* Mise à l'écart automatique : si un bouton d'achat apparaît (ou le tiroir s'ouvre), le popup se cache, puis revient ensuite */
    function sync() {
      if (!isOpen) return;
      if (drawerOpen() || (!forced && mob.matches && buyVisible())) { if (!pop.hidden) { hide(); parked = true; } }
      else if (parked) { parked = false; show(); }
      else if (!pop.hidden) place();
    }
    var raf = 0; window.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); }, { passive: true });
    setInterval(sync, 800);
    document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-orv2-pop-open]'); if (b) { e.preventDefault(); open(true); var i = pop.querySelector('input[type=email]'); if (i) setTimeout(function () { i.focus(); }, 60); } });
    pop.querySelector('[data-close]').addEventListener('click', close);
    if (tab) tab.addEventListener('click', function () { open(true); });
    var form = pop.querySelector('form'); if (form) form.addEventListener('submit', function () { st.done = true; save(st); });
    if (pop.querySelector('[data-success]')) { st.done = true; save(st); open(true); return; }
    if (pop.querySelector('[data-error]')) { open(true); return; }
    if (st.done || /[?&]customer_posted=true/.test(location.search)) return;
    var days = +pop.dataset.days || 7;
    if (st.closed && now - st.closed < days * 864e5) { if (tab) tab.hidden = false; return; }
    var fired = false, delay = (+pop.dataset.delay || 5) * 1000;
    if (mob.matches) delay = Math.max(delay, (+pop.dataset.mdelay || 15) * 1000);
    function fire() { if (fired) return; fired = true; open(false); }
    setTimeout(fire, delay);
    if (!mob.matches) window.addEventListener('scroll', function () { if (window.scrollY > document.documentElement.scrollHeight * 0.45) fire(); }, { passive: true });
  }

  function initPicker(root) {
    root.querySelectorAll('[data-orv2-pick]').forEach(function (sec) {
      if (sec.__pick) return; sec.__pick = true;
      var chips = sec.querySelectorAll('[data-pick]'), panels = sec.querySelectorAll('[data-pick-panel]');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var i = c.dataset.pick;
          chips.forEach(function (x) { var on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
          panels.forEach(function (p) { var on = p.dataset.pickPanel === i; p.hidden = !on; p.classList.remove('is-on'); if (on) { void p.offsetWidth; p.classList.add('is-on'); } });
          if (c.scrollIntoView && c.parentNode.scrollWidth > c.parentNode.clientWidth) c.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });
    });
  }

  function initGift(root) {
    root.querySelectorAll('[data-orv2-gift]').forEach(function (sec) {
      if (sec.__gift) return; sec.__gift = true;
      var id = sec.querySelector('[data-gift-id]'), amt = sec.querySelector('[data-gift-amt]'), btn = sec.querySelector('[data-gift-btn]');
      var rcp = sec.querySelector('[data-gift-rcp]'), err = sec.querySelector('[data-gift-err]'), form = sec.querySelector('form');
      sec.querySelectorAll('[data-gift-v]').forEach(function (c) {
        c.addEventListener('click', function () {
          sec.querySelectorAll('[data-gift-v]').forEach(function (x) { var on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
          id.value = c.dataset.giftV; btn.textContent = c.dataset.giftP; amt.textContent = c.dataset.giftP;
          amt.classList.remove('is-pop'); void amt.offsetWidth; amt.classList.add('is-pop');
        });
      });
      function who() {
        var them = sec.querySelector('[data-gift-who][value="them"]').checked;
        rcp.hidden = !them; if (!them) err.hidden = true;
        rcp.querySelectorAll('input,textarea').forEach(function (f) { f.disabled = !them; });
        var off = sec.querySelector('[data-gift-offset]'); if (off) off.value = new Date().getTimezoneOffset().toString();
      }
      sec.querySelectorAll('[data-gift-who]').forEach(function (r) { r.addEventListener('change', who); });
      var d = sec.querySelector('[data-gift-date]');
      if (d) { var t = new Date(); d.min = t.toISOString().slice(0, 10); t.setDate(t.getDate() + 90); d.max = t.toISOString().slice(0, 10); }
      var ta = rcp.querySelector('textarea'), cnt = sec.querySelector('[data-gift-count]');
      if (ta && cnt) ta.addEventListener('input', function () { cnt.textContent = ta.value.length + '/200'; });
      form.addEventListener('submit', function (e) {
        if (!rcp.hidden) {
          var em = rcp.querySelector('input[type=email]');
          if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value.trim())) { e.preventDefault(); err.hidden = false; em.focus(); return; }
          if (d && !d.value) d.disabled = true;
        }
      });
      who();
    });
  }

  function init(root) {
    root = root || document;
    initEmo(root); initPdpBow(); initGallery(root); initPack(root); initQty(root); initTouchCards(root); initCartUpsell(root); initPopup(); initPicker(root); initGift(root);
    initReveal(root); initTabs(root); initBA(root); initCalc(root); initHotspots(root); initCountdown(root); initCopy(root); initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  // Éditeur de thème Shopify : réinitialiser quand une section est rechargée
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
